import Button from './Button';
import { MenuIcon } from '@heroicons/react/outline';
import { CommonActions, useCommonDispatch } from '@wajeez-web/stores/common';

const InnerPageToggleButton = () => {
  const dispatch = useCommonDispatch();

  return (
    <Button
      color="textPrimary "
      bg="gray-200"
      shape="circle"
      onClick={(e) => {
        e.preventDefault();
        dispatch(CommonActions.toggleInnerPageLayoutSideBarCollapsed());
      }}
      type="text"
      Icon={MenuIcon}
    />
  );
};

export default InnerPageToggleButton;
